import React from "react";
import PropTypes from "prop-types";
import { Tooltip, Typography } from "@mui/material";

export default function StyledTooltip({
  title,
  titleObject,
  ...props
}) {
  return (
    <Tooltip
      title={title ? <Typography variant="body1">{title}</Typography> : titleObject}
      enterDelay={200}
      enterNextDelay={200}
      placement="bottom-start"
      arrow
    >
      {props.children}
    </Tooltip>
  );
}

StyledTooltip.propTypes = {
  title: PropTypes.string,
  titleObject: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  children: PropTypes.node
};